/**
 * Check if a URI leads to an EPS image.
 * @param uri - checked URI
 * @returns True if the URI leads to an EPS image
 */
export const isEpsImage = (uri) => Boolean(uri && uri.trim().match('ebayimg'));
